import { getToken, getToken2, getUser } from "../../Utils/Common"
import { getAPICall, postAPICall } from "../axiosMethodCalls"
import Moment from "moment"

//GET
export const getAllSupplierPayments = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "supplies_payments/get_all_payment",
      {
        requester: getUser(),
        token: getToken(),
        start_date: data.from ? Moment(data.from).format("YYYY-MM-DD") : "",
        end_date: data.to ? Moment(data.to).format("YYYY-MM-DD") : data.to,
        supplier_id: data.supplier_id,
        payment_mode: data.payment_mode,
        doc_no: data.doc_no,
        page: data.page,
      }
    )
    //
    return { data: response.data }
  } catch (error) {
    //
    return { error: error.response }
  }
}

export const getAllSupplierIssuedPayments = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK +
        "supplies_payments/get_all_payment_for_supplies_and_supplies_receive",
      {
        requester: getUser(),
        token: getToken(),
        start_date: data.from ? Moment(data.from).format("YYYY-MM-DD") : "",
        end_date: data.to ? Moment(data.to).format("YYYY-MM-DD") : data.to,
        supplier_id: data.supplier_id,
        payment_mode: data.payment_mode,
        doc_no: data.doc_no,
        page: data.page,
      }
    )
    //
    return { data: response.data }
  } catch (error) {
    //
    return { error: error.response }
  }
}

// //FILTER
// export const searchByDate = async (data) => {
//     try {
//         const response = await getAPICall(
//             process.env.REACT_APP_LINK + "supplies_payments/get_all_payment",
//             {
//                 requester: getUser(),
//                 token: getToken(),
//                 start_date: data.from ? Moment(data.from).format("YYYY-MM-DD") : "",
//                 end_date: data.to
//                     ? Moment(data.to).format("YYYY-MM-DD")
//                     : data.to,
//                 supplier_id: data.supplier_id,
//                 vendor_id: data.vendor_id,
//                 payment_mode: data.payment_mode,
//             }
//         );
//         return { data: response.data };
//     } catch (error) {
//         return { error: error.response };
//     }
// };

//GET SINGLE CASH
export const getSingleCashSP = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "cash_payments/get_slip",
      {
        requester: getUser(),
        token: getToken(),
        slip_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
//GET SINGLE CASH
export const getSingleCashSPPotato = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_POTATO + "cash_payments/get_slip",
      {
        requester: getUser(),
        token: getToken2(),
        slip_id: id,
      },
      "potato"
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
//GET SINGLE CHECK
export const getSingleCheckSP = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "check_payments/get_slip",
      {
        requester: getUser(),
        token: getToken(),
        slip_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
//GET SINGLE CHECK
export const getSingleCheckSPPotato = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_POTATO + "check_payments/get_slip",
      {
        requester: getUser(),
        token: getToken2(),
        slip_id: id,
      },
      "potato"
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
//GET SINGLE BANK
export const getSingleBankSP = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "bank_payments/get_slip",
      {
        requester: getUser(),
        token: getToken(),
        slip_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
//GET SINGLE BANK
export const getSingleBankSPPotato = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_POTATO + "bank_payments/get_slip",
      {
        requester: getUser(),
        token: getToken2(),
        slip_id: id,
      },
      "potato"
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
// GET SINGLE OTHERS
export const getSingleOthersSP = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "other_payments/get_slip",
      {
        requester: getUser(),
        token: getToken(),
        slip_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

//CREATE CHECK PAYMENT
export const createCheckPayment = async (newPayment, items) => {
  try {
    const formData = new FormData()
    newPayment.attachments.map((file) => {
      formData.append(`attachments[]`, file, file.name)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("supplier_id", newPayment.supplier_id)
    formData.append("vendor_id", newPayment.vendor_id)
    formData.append("bank_id", newPayment.bank_id)
    formData.append("check_no", newPayment.check_no)
    formData.append("check_date", newPayment.check_date)
    formData.append("issued_date", newPayment.issued_date)
    formData.append("payee", newPayment.payee)
    formData.append(
      "particulars",
      newPayment.particulars ? newPayment.particulars : ""
    )
    formData.append("acknowledged_by", newPayment.acknowledged_by)
    formData.append("withholding_tax_total", newPayment.withholding_tax_total)
    formData.append("total_amount", newPayment.total_amount)
    formData.append("subtotal", newPayment.subtotal)
    formData.append("total_others", newPayment.total_others)
    formData.append("grand_total", newPayment.grand_total)

    items.map((item) => {
      formData.append(`receive_ids[]`, item.entry.value)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "check_payments/create",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// CREATE CASH PAYMENT
export const createCashPayment = async (newPayment, items) => {
  try {
    const formData = new FormData()
    newPayment.attachments.map((file) => {
      formData.append(`attachments[]`, file, file.name)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("payment_date", newPayment.payment_date)
    formData.append("supplier_id", newPayment.supplier_id)
    formData.append("payee", newPayment.payee)
    formData.append("acknowledged_by", newPayment.acknowledged_by)
    formData.append(
      "particulars",
      newPayment.particulars ? newPayment.particulars : ""
    )
    formData.append("withholding_tax_total", newPayment.withholding_tax_total)
    formData.append("total_amount", newPayment.total_amount)
    formData.append("subtotal", newPayment.subtotal)
    formData.append("total_others", newPayment.total_others)
    formData.append("grand_total", newPayment.grand_total)

    items.map((item) => {
      formData.append(`receive_ids[]`, item.entry.value)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "cash_payments/create",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// CREATE BANK PAYMENT
export const createBankPayment = async (newPayment, items) => {
  try {
    const formData = new FormData()
    newPayment.attachments.map((file) => {
      formData.append(`attachments[]`, file, file.name)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("payment_date", newPayment.payment_date)
    formData.append("bank_from", newPayment.bank_from)
    formData.append("from_account_no", newPayment.from_account_no)
    formData.append("from_account_name", newPayment.from_account_name)
    formData.append("bank_to", newPayment.bank_to)
    formData.append("bank_to_name", newPayment.bank_to_name)
    formData.append("to_account_no", newPayment.to_account_no)
    formData.append("to_account_name", newPayment.to_account_name)
    formData.append("transaction_fee", newPayment.transaction_fee)
    formData.append("reference_no", newPayment.reference_no)
    formData.append("supplier_id", newPayment.supplier_id)
    formData.append("vendor_id", newPayment.vendor_id)
    formData.append("payee", newPayment.payee)
    formData.append(
      "particulars",
      newPayment.particulars ? newPayment.particulars : ""
    )
    formData.append("acknowledged_by", newPayment.acknowledged_by)
    formData.append("withholding_tax_total", newPayment.withholding_tax_total)
    formData.append("total_amount", newPayment.total_amount)
    formData.append("subtotal", newPayment.subtotal)
    formData.append("total_others", newPayment.total_others)
    formData.append("grand_total", newPayment.grand_total)

    items.map((item) => {
      formData.append(`receive_ids[]`, item.entry.value)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "bank_payments/create",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// CREATE OTHERS PAYMENT
export const createOthersPayment = async (newPayment, items, amount) => {
  try {
    const formData = new FormData()
    newPayment.attachments.map((file) => {
      formData.append(`attachments[]`, file, file.name)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("payment_date", newPayment.payment_date)
    formData.append("supplier_id", newPayment.supplier_id)
    formData.append("vendor_id", newPayment.vendor_id)
    formData.append("transaction_type", newPayment.transaction_type)
    formData.append("amount", amount)
    formData.append("transaction_no", newPayment.transaction_no)
    formData.append("payee", newPayment.payee)
    formData.append("acknowledged_by", newPayment.acknowledged_by)
    formData.append(
      "particulars",
      newPayment.particulars ? newPayment.particulars : ""
    )
    formData.append("withholding_tax_total", newPayment.withholding_tax_total)
    formData.append("total_amount", newPayment.total_amount)
    formData.append("subtotal", newPayment.subtotal)
    formData.append("total_others", newPayment.total_others)
    formData.append("grand_total", newPayment.grand_total)

    items.map((item) => {
      formData.append(`receive_ids[]`, item.entry.value)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "other_payments/create",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const deleteBankAttachment = async (values) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...values,
    }
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "bank_payments/delete_attachment",
      payload
    )
    //
    //
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const deleteCashAttachment = async (values) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...values,
    }
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "cash_payments/delete_attachment",
      payload
    )
    //
    //
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const deleteCheckAttachment = async (values) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...values,
    }
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "check_payments/delete_attachment",
      payload
    )
    //
    //
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// UPDATE CHECK PAYMENT
export const updateCheckPayment = async (newPayment, items, id) => {
  try {
    const formData = new FormData()
    newPayment.attachments.map((file) => {
      formData.append("attachments[]", file, file.name)
      formData.append("attachment_ids[]", null)
    })
    newPayment.prev_files.map((file) => {
      formData.append("attachment_ids[]", file.id)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("check_slip_id", id)
    formData.append("supplier_id", newPayment.supplier_id)
    formData.append("vendor_id", newPayment.vendor_id)
    formData.append("bank_id", newPayment.bank_id)
    formData.append("check_no", newPayment.check_no)
    formData.append("check_date", newPayment.check_date)
    formData.append("issued_date", newPayment.issued_date)
    formData.append("payee", newPayment.payee)
    formData.append(
      "particulars",
      newPayment.particulars ? newPayment.particulars : ""
    )
    formData.append("acknowledged_by", newPayment.acknowledged_by)
    formData.append("withholding_tax_total", newPayment.withholding_tax_total)
    formData.append("total_amount", newPayment.total_amount)
    formData.append("subtotal", newPayment.subtotal)
    formData.append("total_others", newPayment.total_others)
    formData.append("grand_total", newPayment.grand_total)

    items.map((item) => {
      formData.append(`receive_ids[]`, item.entry.value)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "check_payments/update",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// UPDATE CASH PAYMENT
export const updateCashPayment = async (newPayment, items, id) => {
  try {
    const formData = new FormData()
    newPayment.attachments.map((file) => {
      formData.append("attachments[]", file, file.name)
      formData.append("attachment_ids[]", null)
    })
    newPayment.prev_files.map((file) => {
      formData.append("attachment_ids[]", file.id)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("cash_slip_id", id)
    formData.append("payment_date", newPayment.payment_date)
    formData.append("supplier_id", newPayment.supplier_id)
    formData.append("vendor_id", newPayment.vendor_id)
    formData.append("payee", newPayment.payee)
    formData.append("acknowledged_by", newPayment.acknowledged_by)
    formData.append(
      "particulars",
      newPayment.particulars ? newPayment.particulars : ""
    )
    formData.append("withholding_tax_total", newPayment.withholding_tax_total)
    formData.append("total_amount", newPayment.total_amount)
    formData.append("subtotal", newPayment.subtotal)
    formData.append("total_others", newPayment.total_others)
    formData.append("grand_total", newPayment.grand_total)

    items.map((item) => {
      formData.append(`receive_ids[]`, item.entry.value)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "cash_payments/update",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
// UPDATE BANK PAYMENT
export const updateBankPayment = async (
  newPayment,
  items,
  transactionFee,
  id
) => {
  try {
    const formData = new FormData()
    newPayment.attachments.map((file) => {
      formData.append("attachments[]", file, file.name)
      formData.append("attachment_ids[]", null)
    })
    newPayment.prev_files.map((file) => {
      formData.append("attachment_ids[]", file.id)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("bank_slip_id", id)
    formData.append("payment_date", newPayment.payment_date)
    formData.append("bank_from", newPayment.bank_from)
    formData.append("from_account_no", newPayment.from_account_no)
    formData.append("from_account_name", newPayment.from_account_name)
    formData.append("bank_to", newPayment.bank_to)
    formData.append("bank_to_name", newPayment.bank_to_name)
    formData.append("to_account_no", newPayment.to_account_no)
    formData.append("to_account_name", newPayment.to_account_name)
    formData.append("transaction_fee", newPayment.transaction_fee)
    formData.append("reference_no", newPayment.reference_no)
    formData.append("supplier_id", newPayment.supplier_id)
    formData.append("vendor_id", newPayment.vendor_id)
    formData.append("payee", newPayment.payee)
    formData.append(
      "particulars",
      newPayment.particulars ? newPayment.particulars : ""
    )
    formData.append("acknowledged_by", newPayment.acknowledged_by.value)
    formData.append("withholding_tax_total", newPayment.withholding_tax_total)
    formData.append("total_amount", newPayment.total_amount)
    formData.append("subtotal", newPayment.subtotal)
    formData.append("total_others", newPayment.total_others)
    formData.append("grand_total", newPayment.grand_total)

    items.map((item) => {
      formData.append(`receive_ids[]`, item.entry.value)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "bank_payments/update",
      formData,
      true
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// UPDATE OTHERS PAYMENT
export const updateOthersPayment = async (newPayment, items, id, amount) => {
  try {
    const formData = new FormData()
    newPayment.attachments.map((file) => {
      formData.append("attachments[]", file, file.name)
      formData.append("attachment_ids[]", null)
    })
    newPayment.prev_files.map((file) => {
      formData.append("attachment_ids[]", file.id)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("other_slip_id", id)
    formData.append("payment_date", newPayment.payment_date)
    formData.append("supplier_id", newPayment.supplier_id)
    formData.append("vendor_id", newPayment.vendor_id)
    formData.append("amount", amount)
    formData.append("transaction_type", newPayment.transaction_type)
    formData.append("transaction_no", newPayment.transaction_no)
    formData.append("payee", newPayment.payee)
    formData.append("acknowledged_by", newPayment.acknowledged_by)
    formData.append(
      "particulars",
      newPayment.particulars ? newPayment.particulars : ""
    )
    formData.append("withholding_tax_total", newPayment.withholding_tax_total)
    formData.append("total_amount", newPayment.total_amount)
    formData.append("subtotal", newPayment.subtotal)
    formData.append("total_others", newPayment.total_others)
    formData.append("grand_total", newPayment.grand_total)

    items.map((item) => {
      formData.append(`receive_ids[]`, item.entry.value)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "other_payments/update",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// DELETE ADVANCE PAYMENT
export const deleteAdvancePayment = async (id) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      purchase_payment_id: id,
    }
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "purchases/delete_payment",
      payload
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// DELETE CHECK
export const deleteCheckSP = async (id) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      check_slip_id: id,
    }
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "check_payments/delete_slip",
      payload
    )
    //
    //
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}
// DELETE CASH
export const deleteCashSP = async (id) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      cash_slip_id: id,
    }
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "cash_payments/delete_slip",
      payload
    )
    //
    //
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}
// DELETE Bank
export const deleteBankSP = async (id) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      bank_slip_id: id,
    }
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "bank_payments/delete_slip",
      payload
    )
    //
    //
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

// DELETE OTHERS
export const deleteOthersSP = async (id) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      other_slip_id: id,
    }
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "other_payments/delete_slip",
      payload
    )
    //
    //
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const createBir2037PurchasePayment = async (id, type) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "Birform/purchase_payment_generate2307",
      {
        requester: getUser(),
        token: getToken(),
        slip_id: id,
        payment_type: type,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}
